/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_FerryInputs */

const fr_vehicle_type_ferry = /** @type {(inputs: Vehicle_Type_FerryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferry`)
};

const en_vehicle_type_ferry = /** @type {(inputs: Vehicle_Type_FerryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferry`)
};

/**
* | output |
* | --- |
* | "Ferry" |
*
* @param {Vehicle_Type_FerryInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_ferry = /** @type {((inputs?: Vehicle_Type_FerryInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_FerryInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_type_ferry(inputs)
	return en_vehicle_type_ferry(inputs)
});